/* eslint-disable react/no-danger */

import React from 'react';
import { observer } from 'mobx-react';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import Button from './Button';

const CommonPopupWithImageComponent = observer(props => {
  const {
    ImgComponent,
    svgImgComponent = '',
    shortInfoText = '',
    titleText = '',
    description = '',
    btnText = '',
    customClass = '',
    customParentClass = '',
    customParentMaskClass = '',
    loading = false,
    actionBtnCallback = () => {},
    clickOutsidePopupCallback = () => {},
    showCloseBtn = false,
    closeClickCallback = () => {},
    animatePopup = false,
    btnSvg = null,
    showCancelBtn = false,
    cancelBtnText = '',
    cancelBtnCallback = () => {},
  } = props;

  return (
    <>
      <div
        className={`common-popup common-image-content-popup ${customParentClass}`}
      >
        <div
          className={`popup-wrap ${customClass} ${
            animatePopup ? 'wiggle' : ''
          }`}
        >
          {showCloseBtn && (
            <div className="close-wrap" onClick={e => closeClickCallback(e)}>
              <CloseIcon />
            </div>
          )}
          <div className="top-wrapper">
            {ImgComponent && <img src={ImgComponent} alt="ImgComponent" />}
            {svgImgComponent}
            {shortInfoText && (
              <div className="short-info-wrap">{shortInfoText}</div>
            )}
          </div>
          <span className="optional-content-wrapper">
            {titleText && <div className="title-wrapper">{titleText}</div>}
            {description && <div className="desc-wrapper">{description}</div>}
          </span>
          <span className="optional-action-wrapper">
            <Button
              btnText={btnText}
              icon={false}
              iconName=""
              type="button"
              className={`action-btn ${loading ? ' loading' : ''}`}
              loader={loading}
              svg={btnSvg}
              click={e => actionBtnCallback(e)}
            />
            {showCancelBtn && (
              <Button
                btnText={cancelBtnText}
                icon={false}
                iconName=""
                type="button"
                className="action-btn cancel-btn"
                loader={loading}
                svg={btnSvg}
                click={e => cancelBtnCallback(e)}
              />
            )}
          </span>
        </div>
      </div>
      <div
        className={`common-popup-mask common-popup-with-image-component-mask ${customParentMaskClass}`}
        onClick={e => clickOutsidePopupCallback(e)}
      />
    </>
  );
});

export { CommonPopupWithImageComponent };
export default CommonPopupWithImageComponent;
